import React, { useState } from "react";
import {
  useParams
} from "react-router-dom";
import MyGroups from "src/Components/Custom/MyGroups/MyGroups";
import GroupsToJoin from "src/Components/Custom/GroupsToJoin/GroupsToJoin";
import EndPoints from "src/Constants/EndPoints";
import GroupDetail from "src/Components/Custom/GroupDetail/GroupDetail";
import { useTranslation } from "react-i18next";

function Groups() {
  const { t, i18n } = useTranslation();
  const params: any = useParams();
  const groupId = Object.keys(params).length !== 0 && params.constructor === Object ? params.id : null;
  const postId = Object.keys(params).length !== 0 && params.constructor === Object ? params.postId : null;

  const [search, setSearch] = useState<string>('');
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);
  const [groupData, setGroupData] = useState<any>([]);

  return (
    <div id="content" className={`${i18n.dir() === 'rtl'?'rtl-content-padding':'ltr-content-padding'}`}>
      <div className="container-fluid">
        <div className="row">
          {groupId ? (
            <GroupDetail
              postId={postId}
              groupId={groupId}
              groupData={groupData}
              setGroupData={setGroupData}
              setModalVisibility={setModalVisibility}
            />
          ) : (
              <>
                <div className="col-md-9">
                  <div className="col_selector">
                    <div className="messages pt-4 update_message post_feed">
                      <div className="d-flex justify-content-between mb-4 align-items-center px-3">
                        <h3 className="fz16 mb-0">{t('Groups')}</h3>
                        <div className="d-flex align-items-center w-50 position-relative cursor-pointer">
                          <img
                            src="assets/images/add group.png"
                            className={`img-fluid ${i18n.dir()==='rtl'?'ml-4':'mr-4'}`}
                            alt=""
                            onClick={() => setModalVisibility(true)}
                          />
                          <input
                            value={search}
                            type="text"
                            className={`form-control fz12  custom_input  ${i18n.dir() === 'rtl' ? 'pl-5 Almaraisemibold' : 'pr-5 poppinsregular'}`}
                            placeholder={t("Search in groups")}
                            onChange={e => setSearch(e.target.value)}
                          />
                          <i className={`fa fa-search ${i18n.dir()==='rtl'?'fa-search-rtl':'fa-search-ltr'}`}></i>
                        </div>
                      </div>
                      <div className="px-3">
                        <MyGroups
                          endPoint={EndPoints.myGroups}
                          groupData={groupData}
                          setGroupData={setGroupData}
                          modalVisibility={modalVisibility}
                          setModalVisibility={setModalVisibility}
                          search={search}
                        />
                      </div>
                      <div className="px-3">
                        <GroupsToJoin
                          endPoint={EndPoints.nearbyGroups}
                          setGroupData={setGroupData}
                          search={search}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      </div>
    </div>
  );
}

export default Groups;
